import React from 'react';
import { styled } from '@slicknode/stylemapper';
import { SPACE } from '@utils/constants';
import { preciseMillify } from '@utils/helpers';
import { getUserPointsRanking } from './helpers';

const BadgeContainer = styled('div', 'flex items-center bg-base800 self-stretch rounded-[40px]', {
  variants: {
    size: {
      sm: 'px-2 py-0.5 text-base-s',
      md: 'px-3 py-2 text-base-m leading-5',
    },
  },
});

const RankText = styled('h3', 'font-base  font-semibold  bg-clip-text text-transparent', {
  variants: {
    badgeRank: {
      Bronze: 'bronze-holographic',
      Silver: 'silver-holographic',
      Gold: 'gold-holographic',
    },
  },
});

export const TotalPointsBadge = ({
  totalPoints,
  size,
}: {
  totalPoints: number;
  size: 'sm' | 'md';
}) => {
  const badgeRank = getUserPointsRanking(totalPoints);
  return (
    <BadgeContainer size={size}>
      <RankText badgeRank={badgeRank}>
        {preciseMillify({
          value: totalPoints,
        })}
      </RankText>
      {SPACE}
      <RankText badgeRank={badgeRank}>pts</RankText>
    </BadgeContainer>
  );
};
